import React from 'react';
// Components
import CampaignDetailsComponent from './CampaignDetails/CampaignDetails';

const CampaignsDetails = (): JSX.Element => {
  return <CampaignDetailsComponent />;
};

export default CampaignsDetails;
